<!--html-->
<template src="../assets/html/functionReserved.html"></template>
<!--css引用-->
<style src="../assets/css/functionReserved.css" lang="css"></style>
<!--js脚本-->

<script>
  import C from "../utils/C";
  export default {
    name: 'MainEnter',
    data () {
      var that = this
      return {
        viewPictureAddress: '',
        bulletFrameDisplay: false, // 图片弹框是否展示
        bannerImg: "", // banner图
        showType:2,///显示的类型，1代表【功能排行榜】、2代表【已上线功能】、3代表【我的反馈】
        funcInfo:"",//输入功能信息
        //网页内容
        tabImageUrl:"",//图片
        praiseImage:"",//点赞后的图片
        faqList:[],
        preservedFuncList:[///预定功能
          // {id:"101110",functionName:"修改个人功能",isFavor:1,favorNum:9871},
        ],
        onlineFuncList:[////已经完成功能
          // {id:"1231",functionName:"修改个人功能"},
        ],
        myFeedbackList: [], // 我的反馈记录
        contactInfo:"",//底部信息

        hadSubmitFuncInfo:false,//是否提交了信息
        submitSuccessShow:false,//提交成功弹窗
        // 图片上传所需
        uploadToken: '',
        deadline: '',
        userUploadImgList: [],
        contactInfoShort: '',
        loadingFinished: false
      }
    },
    mounted() {
      ///获取数据
      //先注册当前的url,通过后端
      var that = this
      this.$netGo.getFunctionList().then(function(result){
        console.log(result)
        // 设置banner
        that.bannerImg = result.bannerImageUrl
        ///////设置数据
        that.tabImageUrl = result.tabImageUrl
        ///点赞的图片
        that.praiseImage = result.praiseImage
        ///////设置数据
        that.faqList = result.faqList
        //预定功能
        that.preservedFuncList = result.functionList || []
        //已完成功能
        that.onlineFuncList = result.onlineFunctionList || []
        // 我的反馈记录
        that.myFeedbackList = result.myFeedbackList || []
        //底部信息
        that.contactInfo = result.contactInfo
        // 上传图片所需
        that.uploadToken = result.uploadToken
        that.deadline = result.deadline
        // 联系qq
        that.contactInfoShort = result.contactInfoShort

        that.loadingFinished = true
      })

      //设置数据为空
      this.$set(this,"funcInfo", "");
      this.userUploadImgList = []
    },
    methods:{
      // 删除用户上传图片
      deleteImageFun:function (index) {
        this.userUploadImgList.splice(index, 1)
      },
      // 生成随机六位码
      getRandomSixNum:function () {
        let RandomSixStr = '';
        for (let i = 0; i < 6; i++) {
          RandomSixStr += String(Math.floor(Math.random() * 10));
        }
        return RandomSixStr;
      },
      // 用户上传图片
      selectFile:function (event) {
        let files = null
        for (let i = 0; i < event.target.files.length; i++) {
          // 获取input上传附件
          files = event.target.files[i];
        }
        const key = this.deadline + '_' + new Date().getTime() + this.getRandomSixNum() + '.' + files.name.split('.')[1]
        // 创建 FormData
        const data = new FormData()
        // 添加数据
        data.append('key', key)
        data.append('file', files)
        data.append('token', this.uploadToken)
        data.append('x:param', JSON.stringify(C.getParam()))
        data.append('x:systemParam', JSON.stringify(C.getSystemInfo()))
        // 发起请求
        this.$netGo.addUploadImage(data).then(res => {
          this.userUploadImgList.push(res.imageUrl)
        })
      },

      switchType:function($event,type){
        //切换的新类型
        this.showType = type;
      },
      clickFavor:function($event,functionId,favorIndex){
        console.log(functionId+","+favorIndex)
        //点赞取相反
        var newFavor = 1-this.preservedFuncList[favorIndex].isFavor
        this.preservedFuncList[favorIndex].isFavor = newFavor
        if(this.preservedFuncList[favorIndex].isFavor == 1){
          this.preservedFuncList[favorIndex].favorNum += 1
        }else{
          this.preservedFuncList[favorIndex].favorNum -= 1
        }

        ///点赞
        this.$netGo.setFunctionFavor(functionId,newFavor).then(function (result) {
          console.log("收藏设置成功:"+newFavor)
        })
      },

      submitFuncInfo:function(){////提交需求
        var funcInfo = this.$data.funcInfo.trim()
        //必须有数据
        if(funcInfo == undefined || funcInfo == null || funcInfo == ""){
          this.funcInfo = ""
          alert("输入数据不能为空.")
          return
        }
        //定义数据格式为字符串
        var that = this
        console.log(funcInfo)
        this.$netGo.addFunctionMore(funcInfo, this.userUploadImgList).then(function(result){
          // alert("感谢提交成功，我们将会及时核验功能!")
          that.funcInfo = ""
          that.userUploadImgList = []
          ///加载成功标示
          // that.hadSubmitFuncInfo = true
          // //定时器显示成功
          that.submitSuccessShow = true
          setTimeout(function () {
            //关闭
            that.submitSuccessShow = false
          },2000)
          // 重新拿取我的反馈列表
          that.myFeedbackList = result.myFeedbackList
          that.showType = 3
          that.backTheTop()
        })
      },
      // 回到顶部
      backTheTop: function () {
        const dom = document.querySelector('#functionReserved')
        const dom2 = document.querySelector('.reserve-list')
        console.log(dom.scrollTop, 'dom2', dom2.scrollTop)
        dom.scrollTop = 0
        dom2.scrollTop = 0
      },
      //跳转问题详情
      gotoProblemDetail:function (event) {
        var id = event.currentTarget.dataset.id;
        //当前域名
        var domain = document.domain;
        var url ='https://'+domain+'/problemDetail?id='+id
        window.location.href=url;
      },
      openPopUpBox: function (address, item) {
        console.log(address, item)
        this.viewPictureAddress = address
        this.bulletFrameDisplay = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/FunctionReserved.vue